import React, { useState, useEffect } from 'react';
import { tokenUtils } from '../services/tokenManager';

interface TokenStatusProps {
  showDebug?: boolean;
}

const TokenStatus: React.FC<TokenStatusProps> = ({ showDebug = false }) => {
  const [tokenInfo, setTokenInfo] = useState(tokenUtils.getExpirationInfo());
  const [isRefreshing, setIsRefreshing] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setTokenInfo(tokenUtils.getExpirationInfo());
    }, 1000); // Update every second

    return () => clearInterval(interval);
  }, []);

  const handleForceRefresh = async () => {
    setIsRefreshing(true);
    try {
      const success = await tokenUtils.forceRefresh();
      if (success) {
        setTokenInfo(tokenUtils.getExpirationInfo());
      }
    } catch (error) {
      console.error('Force refresh failed:', error);
    } finally {
      setIsRefreshing(false);
    }
  };

  const formatTime = (milliseconds: number): string => {
    if (milliseconds <= 0) return 'Expired';
    
    const minutes = Math.floor(milliseconds / (1000 * 60));
    const seconds = Math.floor((milliseconds % (1000 * 60)) / 1000);
    
    return `${minutes}m ${seconds}s`;
  };

  const getStatusColor = (): string => {
    if (!tokenInfo.isValid) return 'red';
    if (tokenInfo.expiresIn < 5 * 60 * 1000) return 'orange'; // Less than 5 minutes
    return 'green';
  };

  if (!showDebug) {
    return null;
  }

  return (
    <div style={{
      position: 'fixed',
      top: '10px',
      right: '10px',
      background: '#f5f5f5',
      border: '1px solid #ddd',
      borderRadius: '4px',
      padding: '10px',
      fontSize: '12px',
      zIndex: 9999,
      minWidth: '200px',
    }}>
      <div style={{ fontWeight: 'bold', marginBottom: '5px' }}>
        Token Status
      </div>
      
      <div style={{ marginBottom: '5px' }}>
        <span style={{ color: getStatusColor() }}>
          ● {tokenInfo.isValid ? 'Valid' : 'Invalid'}
        </span>
      </div>
      
      {tokenInfo.isValid && (
        <div style={{ marginBottom: '5px' }}>
          Expires in: {formatTime(tokenInfo.expiresIn)}
        </div>
      )}
      
      {tokenInfo.expiresAt && (
        <div style={{ marginBottom: '10px', fontSize: '10px' }}>
          Expires at: {tokenInfo.expiresAt.toLocaleTimeString()}
        </div>
      )}
      
      <button
        onClick={handleForceRefresh}
        disabled={isRefreshing}
        style={{
          background: '#007bff',
          color: 'white',
          border: 'none',
          borderRadius: '3px',
          padding: '5px 10px',
          fontSize: '11px',
          cursor: isRefreshing ? 'not-allowed' : 'pointer',
        }}
      >
        {isRefreshing ? 'Refreshing...' : 'Force Refresh'}
      </button>
    </div>
  );
};

export default TokenStatus; 